export default "__VITE_ASSET__DQnFjOol__"